export enum AuthAction {
  Login = 'login',
  ClearSessionLogin = 'clear-session-login',
  Logout = 'logout',
  ForgotPassword = 'forgot-password',
  ResetPassword = 'reset-password',
}
